import styled from 'styled-components'
import DataTable from "react-data-table-component";

export const RatingTable = styled(DataTable)`
  border-collapse: collapse;
  margin-top: 20px;
  .rdt_TableCol,
  .rdt_TableCell
  /* .rdt_TableRow, */
  /* .rdt_TableRow  */ {
    border: 1px solid #e5e5e5;
    border-collapse: collapse;
  }

  .sc-bfjaSH {
    text-align: center;
    width: 100%;
  }

  .rdt_TableHeadRow {
    border: none;
  }

  .hWGUPT:not(:last-of-type) {
    border: none;
  }
`;
